import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, palette, shadows }) => ({
  root: {
    borderRadius: "12px"
  },
  container: {
    background: palette.common.white,
    boxShadow: shadows[2]
  },
  loading: {
    height: "220px"
  },
  details: {
    padding: spacing(4),
    display: "flex",
    flexDirection: "column",
    rowGap: spacing(5)
  },
  breadcrumbs: {},
  divider: {
    fontWeight: 400
  },
  tooltipIcon: {
    marginLeft: spacing(2),
    color: palette.primary[500]
  },
  mutedText: {
    color: palette.primary[500]
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(2)
  },
  title: {
    fontWeight: 500,
    color: palette.text.primary,
    paddingLeft: spacing(4)
  },
  titleTooltipIcon: {
    color: palette.primary[500]
  }
}))
